module.exports = __webpack_public_path__ + "static/media/cardCollectionAgentGrayBg.d36e0bd2.png";